import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=08c7ff24&scoped=true&"
import script from "./error-message.vue?vue&type=script&lang=js&"
export * from "./error-message.vue?vue&type=script&lang=js&"
import style0 from "./error-message.vue?vue&type=style&index=0&id=08c7ff24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7ff24",
  null
  
)

export default component.exports